import { render, staticRenderFns } from "./MedicineAnalogsInformation.vue?vue&type=template&id=1e42380b&scoped=true"
import script from "./MedicineAnalogsInformation.vue?vue&type=script&lang=js"
export * from "./MedicineAnalogsInformation.vue?vue&type=script&lang=js"
import style0 from "./MedicineAnalogsInformation.vue?vue&type=style&index=0&id=1e42380b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e42380b",
  null
  
)

export default component.exports